/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inbound_Field_Pickup_ContactInputs */

const en_inbound_field_pickup_contact = /** @type {(inputs: Inbound_Field_Pickup_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pickup contact`)
};

/**
* | output |
* | --- |
* | "Pickup contact" |
*
* @param {Inbound_Field_Pickup_ContactInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const inbound_field_pickup_contact = /** @type {((inputs?: Inbound_Field_Pickup_ContactInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbound_Field_Pickup_ContactInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_inbound_field_pickup_contact(inputs)
});